export default "__VITE_ASSET__D$HDaTH2__"